import React from 'react';
import { Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
// route Auth
import Auth from './../routes/Auth';
// components
import Layout from './../containers/Layout/Layout';
import LoginPage from './../containers/Auth/LoginPage';
import UserPage from './../containers/UserPage/UserPage';
import CoursePage from './../containers/CoursePage/CoursePage';
import CourseModulePage from './../containers/CourseModulePage/CourseModulePage';
import ModuleQuestionPage from './../containers/ModuleQuestionPage/ModuleQuestionPage';
import BatchPage from './../containers/BatchPage/BatchPage';
import BatchParticipantPage from './../containers/BatchParticipantPage/BatchParticipantPage';
import DashboardPage from './../containers/DashboardPage/DashboardPage';
import MockexamPage from './../containers/MockexamPage/MockexamPage';
import TrainerPage from '../containers/TrainerPage/TrainerPage';
import SalesExecutivePage from '../containers/SalesExecutivePage/SalesExecutivePage';

// pagenotfound
import PageNotFound from './PageNotFound';

const Routes = ({match, history}) => {
    return(
        <Switch>
            <Route path={match.url} exact component={Auth(LoginPage, false)} />
            <Route path={`${match.url}login`} exact component={Auth(LoginPage, false)} />
            <Route path={`${match.url}mockexam`} component={Auth(MockexamPage, true, false)} />
            <Layout match={match} history={history}>
                <Route path={`${match.url}course`} exact component={Auth(CoursePage, true, true)} />
                <Route path={`${match.url}course/cm/:course_id`} exact component={Auth(CourseModulePage, true, true)} />
                <Route path={`${match.url}course/cm/:course_id/mq/:module_id`} exact component={Auth(ModuleQuestionPage, true, true)} />
                <Route path={`${match.url}user`} exact component={Auth(UserPage, true, true)} />
                <Route path={`${match.url}trainer`} exact component={Auth(TrainerPage, true, true)} />
                <Route path={`${match.url}salesexecutive`} exact component={Auth(SalesExecutivePage, true, true)} />
                <Route path={`${match.url}batch`} exact component={Auth(BatchPage, true, true)} />
                <Route path={`${match.url}batch/bp/:batch_id`} component={Auth(BatchParticipantPage, true, true)} />
                <Route path={`${match.url}dashboard`} exact component={Auth(DashboardPage, true, false)} />
            </Layout>
            <Route component={Auth(PageNotFound)} />    
        </Switch> 
    );
}

Routes.propTypes = {
    match: PropTypes.instanceOf(Object),
    history: PropTypes.instanceOf(Object)
};

Routes.defaultProps = {
    match: {},
    history: {}
};

export default Routes;



// WEBPACK FOOTER //
// ./routes/Routes.js